import React from 'react'

// material ui
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

// containers
import ErrorMessage from 'components/shared/ErrorMessage'

// atomic components
import Loading from 'components/atoms/Loading'
import Breadcrumbs from 'components/shared/Breadcrumbs'

// components
import ReupHeader from './ReupHeader'
import AddDaysHeader from './AddDaysHeader'
import Form from './Form'

const Cart = props => {
  const {
    loading, // via withQuery
    account, // via withQuery
    season, // via withQuery
    sessions, // via withQuery
    enableCovidRequirements // via withQuery
  } = props

  const { registrationStatus, preferences } = account || {}
  const { reupRequired, registered } = registrationStatus || {}
  const { onlineOnly = true } = preferences || {}

  return (
    <Container maxWidth='md'>
      <Box mt={2}>
        <Breadcrumbs
          crumbs={[
            ['Plans', '/plans'],
            ['Shopping Cart', '/plans/cart']
          ]}
        />
        <ErrorMessage />
      </Box>

      {!account || loading ? (
        <Loading />
      ) : (
        <>
          {reupRequired && !registered && (
            <ReupHeader
              account={account}
              season={season}
              onlineOnly={onlineOnly}
              enableCovidRequirements={enableCovidRequirements}
            />
          )}
          {registered && (
            <AddDaysHeader
              onlineOnly={onlineOnly}
              enableCovidRequirements={enableCovidRequirements}
            />
          )}
          <Form {...props} sessions={sessions} />
        </>
      )}
    </Container>
  )
}

export default Cart
